import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BomCookieService } from 'src/app/core/services/bom-cookie/bom-cookie.service';

@Component({
  selector: 'bom-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
})
export class CookieBannerComponent implements OnInit {
  isCookieBannerShown$ = new BehaviorSubject<boolean>(true);
  cookieHideCookieBanner = 'hideCookieBanner';

  constructor(private bomCookieService: BomCookieService) {}

  ngOnInit() {
    const cookieHideCookieBannerValue = this.bomCookieService.get(this.cookieHideCookieBanner);
    const showCookieBanner = cookieHideCookieBannerValue
      ? cookieHideCookieBannerValue === 'false'
      : true;
    this.isCookieBannerShown$.next(showCookieBanner);
  }

  setCookieAcceptCookiesValue() {
    this.bomCookieService.set(this.cookieHideCookieBanner, 'true');
    this.isCookieBannerShown$.next(false);
  }
}
